import { createActions, createReducer } from 'reduxsauce'

import EscolaridadeCurriculos from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEscolaridadeCurriculosInicio: [],
    buscaEscolaridadeCurriculosSucesso: ['escolaridadeCurriculos'],
    buscaEscolaridadeCurriculosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaEscolaridadeCurriculos = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEscolaridadeCurriculosInicio())
        let serv = new EscolaridadeCurriculos()
        return serv
            .detalhesEscolaridadeCurriculos(filtro)
            .then(response => dispatch(Creators.buscaEscolaridadeCurriculosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEscolaridadeCurriculosErro(error)))
    }
}

const buscaEscolaridadeCurriculosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEscolaridadeCurriculosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaEscolaridadeCurriculosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.escolaridadeCurriculos.resultado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ESCOLARIDADE_CURRICULOS_INICIO]: buscaEscolaridadeCurriculosInicio,
    [Types.BUSCA_ESCOLARIDADE_CURRICULOS_ERRO]: buscaEscolaridadeCurriculosErro,
    [Types.BUSCA_ESCOLARIDADE_CURRICULOS_SUCESSO]: buscaEscolaridadeCurriculosSucesso,
})
